import { t } from 'i18next';
import React from 'react';

type AuthLayoutProps = {
    children: React.ReactNode;
    heading?: string;
    subheading?: string;
};

/** Wraps the word "operations" in a highlighted <em> if found in the heading string */
function HeadlineWithHighlight({ text }: { text: string }) {
    const keyword = 'operations';
    const idx = text.toLowerCase().indexOf(keyword);
    if (idx === -1) return <>{text}</>;
    return (
        <>
            {text.slice(0, idx)}
            <em className="auth-headline-em">{text.slice(idx, idx + keyword.length)}</em>
            {text.slice(idx + keyword.length)}
        </>
    );
}

const AuthLayout = (props: AuthLayoutProps) => {
    return (
        <div className="auth-shell position-relative overflow-hidden">
            <div className="auth-shell-bg position-absolute" aria-hidden="true" />

            {/* ── LEFT PANEL ── */}
            <section className="auth-login-panel d-flex flex-column justify-content-between position-relative" aria-label="Metalmark app login">
                {/* Top bar */}
                <div className="auth-top-bar d-flex align-items-center justify-content-between">
                    <img
                        src={require('assets/images/metalmark-monogram.png')}
                        className="auth-monogram h-auto cursor-pointer"
                        alt="Metalmark"
                        onClick={() => window.open('https://metalmark.xyz/', '_blank')}
                       
                    />
                    <a
                        className="auth-return-link no-underline font-body"
                        href="https://metalmark.xyz/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('back_website')}
                    </a>
                </div>

                {/* Copy + form */}
                <div className="auth-copy-wrap">
                    <div className="auth-eyebrow title-2-bold text-uppercase">{t('metalmark_app')}</div>
                    <div className="auth-headline">
                        {props.heading ? (
                            <HeadlineWithHighlight text={props.heading} />
                        ) : (
                            <>
                               {t('environmental')} <em className="auth-headline-em">{t('operations')}</em>{' '}
                                {t('need_it')}
                            </>
                        )}
                    </div>
                    {props.subheading && <p className="auth-subheading">{props.subheading}</p>}

                    {/* Form card */}
                    <div className="auth-form-card">{props.children}</div>
                </div>

                {/* Footer */}
                <footer className="d-flex justify-content-center auth-footer font-base">
                    <span>{t('trademark')}</span>
                    <a href="https://metalmark.xyz/contact/">{t('contact_support')}</a>
                    <a href="https://www.metalmark.xyz/privacy-policy/">{t('privacy_policy')}</a>
                </footer>
            </section>

            {/* ── RIGHT VISUAL PANEL ── */}
            <section className="auth-visual-panel d-flex align-items-stretch position-relative" aria-label="Metalmark spatial workspace">
                <div
                    className="auth-visual-card flex-grow-1 position-relative overflow-hidden"
                    style={{
                        backgroundImage: `
                            linear-gradient(90deg, rgba(6,14,28,.52), rgba(6,14,28,.06) 44%, rgba(6,14,28,.3)),
                            url(${require('assets/images/metalmark-spatial-workspace.png')})
                        `,
                        backgroundSize: '165%',
                    }}
                >
                    <div className="auth-visual-copy position-absolute text-white">
                        <span className="auth-visual-tag d-inline-flex text-uppercase text-white">{t('spatial_workspace')}</span>
                        <h2 className="auth-visual-headline">
                           {t('measure')} <span className="auth-visual-accent">{t('Verify')}</span>
                        </h2>
                        <p className="auth-visual-body">
                            {t('img_subheader')}
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AuthLayout;
